<template>
  <div class="remarks-item">
    <div class="profile">
      <img :src="itemInfo.userPhoto || require('@/assets/img/avatar.png')" />
    </div>
    <ul>
      <li>
        <label class="username">
          {{ itemInfo.createUserName }}
          <template v-if="itemInfo.toUserName">
            <span style="color: #8a8a8a">回复</span> {{ itemInfo.toUserName }}
          </template>
          :
        </label>
        <span class="desc">{{ itemInfo.content }}</span>
      </li>
      <li class="li-operation">
        <!-- <span class="date">{{ itemInfo.ctime }}</span> -->
        <span
          class="operation-item"
          :class="{ active: itemInfo.isLilke === '1' }"
          @click="onLike"
        >
          <i class="icon-like"></i>
          <span>赞</span>
          <span v-if="itemInfo.likeCount && itemInfo.likeCount > 0"
            >（{{ itemInfo.likeCount }}）</span
          >
        </span>
        <span class="operation-item" @click="showReply = !showReply">
          <i class="el-icon-chat-dot-square"></i>
          <span>回复</span>
        </span>
        <!-- <i class="icon-like">
          <span class="reply-letter">赞</span>
        </i> -->
        <!-- <i class="el-icon-chat-dot-square">
          <span class="reply-letter" >回复</span>
        </i> -->
      </li>
      <li :style="{ 'max-height': showReply ? '50px' : '0px' }">
        <div class="search-inner">
          <el-input
            v-model="replyText"
            @keyup.enter.native="toReply"
            placeholder="请输入回复内容"
            class="search-input"
          >
          </el-input>
          <el-button
            type="primary"
            class="search-btn"
            size="small"
            @click="toReply"
            >回复</el-button
          >
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { axiosFactory } from '@/services/axios-factory'
const {
  VUE_APP_APPNAME,
  VUE_APP_APPKEY,
  VUE_APP_SSOSERVERURL,
  VUE_APP_LOGINREDIRECTURL,
} = process.env

export default {
  name: 'RemarksItem',
  components: {},
  data () {
    return {
      replyText: '',
      showReply: false,
    }
  },
  props: {
    itemInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  created () { },
  computed: {
    localComputed () { },
    ...mapState({
      loginStatus: (state) => state.loginStatus.valueOf(),
    }),
  },
  watch: {
    itemInfo (val) {
      this.showReply = false
      this.replyText = ''
    },
  },
  methods: {
    toReply () {
      let param = {
        resourceId: this.$route.query.detailId, // 资源id
        content: this.replyText.trim(), // 回复内容
        toCommentId: this.itemInfo.id, //  id
        toUserId: this.itemInfo.creator,
      }
      this.$emit('add-remark', param)
    },
    onLike () {
      // SSO配置
      window.SSO.appName = VUE_APP_APPNAME
      window.SSO.appKey = VUE_APP_APPKEY
      window.SSO.SSOServerUrl = VUE_APP_SSOSERVERURL
      window.SSO.loginRedirectUrl = VUE_APP_LOGINREDIRECTURL
      // 登录状态
      window.SSO.getLoginState((res) => {
        const isLogin = res.code === 1001
        if (isLogin) {
          window.localStorage.setItem('st', res.data.st)
          window.localStorage.setItem('tgt', res.data.tgt)
          const params = { id: this.itemInfo.id }
          this.axiosLike(params)
        } else {
          window.open(VUE_APP_LOGINREDIRECTURL, '_blank')
        }
      })
    },
    // 点赞接口
    async axiosLike (params) {
      const url = 'res/updateLikeCount'
      await axiosFactory({ url, params })
      const message = this.itemInfo.isLilke === '1' ? '取消点赞！' : '点赞成功！'
      this.$message.success(message)
      this.$emit('update')
    }
  },
}
</script>

<style scoped lang="less">
.remarks-item {
  display: flex;
  padding: 15px 0;
  border-bottom: 1px dashed #f0f0f0;
  .profile {
    width: 60px;
    img {
      width: 50px;
      height: 50px;
    }
  }
  ul {
    // flex: 1;
    width: calc(100% - 60px);
  }
  li:first-child {
    margin-bottom: 10px;
    font-size: 16px;
    // overflow-y: auto;
    .username {
      color: #4a97f9;
    }
    .desc {
      color: #8a8a8a;
      // white-space: nowrap;
    }
  }
  li:nth-child(2) {
    font-size: 13px;
    color: #8a8a8a;
  }
  li:last-child {
    overflow: hidden;
    max-height: 0px;
    margin-top: 10px;
    transition: all 400ms linear;
    .search-inner {
      display: flex;
      align-items: center;
      width: 500px;
      height: 30px;
      border-radius: 5px;
      background: #fff;
      // padding: 1px 3px;
      .search-input {
        display: contents;
        margin-right: 10px;
      }
      .search-btn {
        float: right;
      }
    }
  }
  .li-operation {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .operation-item {
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      color: #8a8a8a;
      &.active,
      &:hover {
        color: #4a97f9;
        .icon-like {
          background: url(../../../assets/img/icon-like-hover.png) left center
            no-repeat;
        }
      }
    }
    .operation-item i {
      margin-right: 3px;
    }
    .operation-item + .operation-item {
      margin-left: 10px;
    }
  }
  .el-icon-chat-dot-square {
    font-size: 16px;
  }
  // .reply-letter {
  //   font-size: 12px;
  //   margin-left: 5px;
  //   display: inline-block;
  //   vertical-align: middle;
  //   cursor: pointer;
  //   &:hover {
  //     // & 代表内部的它自己
  //     color: #4a97f9;
  //   }
  // }
}
.search-inner /deep/ .el-input__inner {
  height: 30px;
  margin-right: 10px;
  line-height: 30px;
}
.search-inner /deep/ .el-button--small {
  height: 30px;
}
.icon-like {
  // padding-left: 18px;
  width: 18px;
  height: 18px;
  font-style: normal;
  background: url(../../../assets/img/icon-like.png) left center no-repeat;
}
</style>
